module.exports = __webpack_public_path__ + "img/vse_instrumenti.e2e45115.svg";